import { css, Global } from '@emotion/react';

export const GlobalStyles = () => {
  return (
    <Global
      styles={css`
        body {
          font-family: General Sans, sans-serif;
          margin: 0;
        }

        input,
        button,
        textarea {
          font-family: inherit;
          color: inherit;
        }
      `}
    />
  );
};
